import { render, staticRenderFns } from "./VTextarea.vue?vue&type=template&id=e002e866&"
import script from "./VTextarea.vue?vue&type=script&lang=ts&"
export * from "./VTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./VTextarea.vue?vue&type=style&index=0&id=e002e866&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports